import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Query from '../views/Products/Query'
import Login from '../views/Login'
import Account from '../views/Account'
import WarrantyCreditRequest from '../views/WarrantyCreditRequest'
import WarrantyRequest from '../views/WarrantyRequest'
import WarrantyApproval from '../views/WarrantyApproval'
import Part from "../views/Parts/Part"
import Product from "../views/Products/Product"
import Parts from "../views/Parts/Parts"
import Products from "../views/Products/Products"
import store from "@/store";
import SignIn from "@/views/auth/SignIn.vue";
import SignUp from "@/views/auth/SignUp.vue";
import SignOut from "@/views/auth/SignOut.vue";
import ConfirmSignUp from "@/views/auth/ConfirmSignUp.vue";
import PasswordReset from "@/views/auth/PasswordReset.vue";
import ChangePassword from "@/views/auth/ChangePassword.vue";
import ConfirmPasswordReset from "@/views/auth/ConfirmPasswordReset.vue";
import DisplayProducts from '@/views/Products/DisplayProducts.vue';
import WarrantyArchive from '@/views/WarrantyArchive.vue'
import UserRegisterItem from '@/views/UserRegisterItem.vue'
import Item from '@/views/Items'
import Company from '@/views/Company'
import CompanyApproval from '@/views/CompanyApproval.vue'
import AddToAdmin from '@/views/AddToAdmin.vue'
import RemoveFromAdmin from '@/views/RemoveFromAdmin'
import ServiceCode from '@/views/ServiceCode'
import AddServiceParts from '@/views/AddServiceParts'
import AddPartsToProduct from '@/views/AddPartsToProduct'
import BatchImport from '@/views/BatchImport'
import HeaderUtil from '@/views/HeaderUtil'
import User from '@/views/Users'
import UserRoles from '@/views/UserRoles'
import AdminManager from '@/views/AdminManager'
import Admin from '@/views/Admin.vue';
import Reports from '@/views/Reports.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: { title: "Admin", auth: true, admin: true },
    children:[
    {
      path: 'item',
      name: 'Item',
      component: Item,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'header-utilities',
      name: 'HeaderUtil',
      component: HeaderUtil,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'company',
      component: Company,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'company-approvals',
      component: CompanyApproval,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'add-to-admin',
      component: AddToAdmin,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'company',
      name: 'Company',
      component: Company,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'company-approvals',
      name: 'CompanyApproval',
      component: CompanyApproval,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'remove-from-admin',
      component: RemoveFromAdmin,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'service-code',
      name: 'ServiceCode',
      component: ServiceCode,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'service-parts',
      name: 'AddServiceParts',
      component: AddServiceParts,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'parts-to-product',
      name: 'AddPartsToProduct',
      component: AddPartsToProduct,
      meta: { title: "Admin", auth: true, admin: true }
    },     
    {
      path: 'batch-import',
      name: 'BatchImport',
      component: BatchImport,
      meta: { title: "Admin", auth: true, admin: true }
    },   
    {
      path: 'user',
      name: 'User',
      component: User,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'user-roles',
      name: 'UserRoles',
      component: UserRoles,
      meta: { title: "Admin", auth: true, admin: true }
    },     
    {
      path: 'admin-manager',
      name: 'AdminManager',
      component: AdminManager,
      meta: { title: "Admin", auth: true, admin: true }
    },
    {
      path: 'products-list',
      name: 'ProductList',
      component: Products,
      meta: { title: "Admin", auth: true, admin: true }
    },     
    {
      path: "products-list/:id",
      name: "Product",
      component: Product,
      meta: { title: "Product Detail Page", auth: true, admin: true }
    },    
    {
      path: 'parts-list',
      name: 'PartList',
      component: Parts,
      meta: { title: "Admin", auth: true, admin: true }      
    },
    {
      path: "/parts-list/:id",
      name: "Part",
      component: Part,
      meta: { title: "Part Detail Page", auth: true, admin: true }
    }, 
    {
      path: "/reports",
      name: "Reports",
      component: Reports,
      meta: { title: "Reporting", auth: true, admin: true }
    },                      
  ],
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: "Login", auth: false }
  },
  {
    path: '/signUp',
    name: 'SignUp',
    component: SignUp,
    meta: { title: "Sign Up", auth: false }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: "Home", auth: true }
  },
  {
    path: '/archive',
    name: 'Archive',
    component: WarrantyArchive,
    meta: { title: "Archive", auth: true, admin: true }
  },
  {
    path: '/register-item',
    name: 'RegisterItem',
    component: UserRegisterItem,
    meta: { title: "Archive", auth: true }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: { title: "Account", auth: true }
  },
  {
    path: '/warranty-request',
    name: 'WarrantyRequest',
    component: WarrantyRequest,
    meta: { title: "Warranty Requests", auth: true }
  },
  {
    path: '/products',
    name: 'Products',
    component: DisplayProducts,
    meta: { title: "Product Catalog", auth: true }
  },
  {
    path: '/report-builder',
    name: 'Query',
    component: Query,
    meta: { title: "Sign In", auth: true }
  },
  {
    path: '/warranty-credit-request',
    name: 'WarrantyCreditRequest',
    component: WarrantyCreditRequest,
    meta: { title: "Warranty Request", auth: true }
  },
  {
    path: '/warranty-credit-request/:id',
    name: 'WarrantyApproval',
    component: WarrantyApproval,
    meta: { title: "Approve Request", auth: true, admin:true }
  },
  {
    path: "/signIn",
    name: "signIn",
    component: SignIn,
    meta: { title: "Sign In", auth: false }
  },
  {
    path: "/signOut",
    name: "signOut",
    component: SignOut,
    meta: { title: "Sign Out", auth: true }
  },
  {
    path: "/signUp",
    name: "signUp",
    component: SignUp,
    meta: { title: "Sign Up", auth: false }
  },
  {
    path: "/confirmSignUp",
    name: "confirmSignUp",
    component: ConfirmSignUp,
    meta: { title: "Confirm SignUp", auth: false }
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: ChangePassword,
    meta: { title: "Change Password", auth: true }
  },
  {
    path: "/passwordReset",
    name: "passwordReset",
    component: PasswordReset,
    meta: { title: "Password Reset", auth: false }
  },
  {
    path: "/confirmPasswordReset",
    name: "confirmPasswordReset",
    component: ConfirmPasswordReset,
    meta: { title: "Confirm Password Reset", auth: false }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth && to.meta.admin){
      if (store.getters["auth/isAdmin"] != false) {
        next();
        return;
      }
      router.push({ name: "Home" });
      return;
    }

    if (to.meta.auth) {
      if (store.getters["auth/isAuthenticated"]) {
        next();
        return;
      }
      router.push({ name: "Login" });
      return;
    }
    if (store.getters["auth/isAuthenticated"]) {
      router.push({ name: "Home" });
      return;
    }
    next();
    return;
  }
  next();
  return;
});

export default router;